export default "__VITE_ASSET__Kv3o58F4__"